import React, { useState } from "react";
import style from "./index.module.css";
import Img from "../../components/Image";
import Questions from "../questions";

function InputCredential() {
  const [credential, setCredential] = useState("");

  const handleCredentialChange = (event) => {
    setCredential(event.target.value);
  };

  const handleSubmit = () => {
    //console.log("Entered Credential:", credential);
    setCredential("");
  };
  return (
    <div>
      <div className={style.inputContainer}>
        <div className={style.inputContentContainer}>
          <div className={style.inputLeft}>
            <div className={style.inputLeftContent}>
              <input
                placeholder="Insert your Audit Credential ID"
                className={style.inputLeftInputData}
                value={credential}
                onChange={handleCredentialChange}
                maxLength={20}
              />
              <span className={style.inputLeftHidepw}>
                <Img
                  src="https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2FinputCredentials%2FhidePw.webp?alt=media&token=30ed0ad5-d094-47cf-a6da-17b4ff45ee0a"
                  className={style.inputLeftHidepwImg}
                  alt="Hide Password"
                ></Img>
              </span>
            </div>
            <div className={style.inputLeftBtnCont}>
              <button className={style.inputLeftBtn} onClick={handleSubmit}>
                <Img
                  src="https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2FinputCredentials%2Farrow.webp?alt=media&token=1d1aa683-a037-4fbb-95b5-95eb657bb648"
                  alt="Submit"
                ></Img>
              </button>
            </div>
          </div>
          <div className={style.inputRight}>
            <p>Where is my Audit Credential ID?</p>
            <Img src="https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2FinputCredentials%2Finfo.webp?alt=media&token=5ad87cd8-b962-47ee-bfb0-ed5d91f66a27"></Img>
          </div>
        </div>
      </div>
      <br />
      <Questions />
    </div>
  );
}

export default InputCredential;
